import React, { Component } from 'react';
import { FacebookProvider, Page } from 'react-facebook';
import { variable } from './Function';
import '../css/Footer.css';
import logo from '../assets/image/logo_gsb.png';

class AppFooter extends Component {
  constructor() {
    super();
    this.BaseUrl = variable().BASE_URL;
    this.state = {
      about: { 
        history: this.BaseUrl + 'page.php?pid=1',
        ceo: this.BaseUrl + 'page.php?pid=6',
        staff: this.BaseUrl + 'page.php?pid=7'
      },
      service: {
        member: this.BaseUrl + 'page.php?pid=2',
        scheduleLoan: this.BaseUrl + 'uploads/document/4/20180820944567j2SNIA.pdf',
        example: this.BaseUrl + 'uploads/document/2/201805221549380nUbIba.pdf',
        schedule: this.BaseUrl + 'uploads/document/3/20180522155115z3KGD45.pdf',
        serviceLoan: this.BaseUrl + 'page.php?pid=3',
        info: this.BaseUrl + 'page.php?pid=4'
      },
      performance: this.BaseUrl + 'page.php?pid=26',
      account: this.BaseUrl + 'page.php?pid=19',
      contact: this.BaseUrl + 'contact_map.php',
      showFooter: false
    };
  }

  componentDidMount() {
    const Path = window.location.pathname;
    const url = Path.split('/');
    if ( url[2] === 'read' && url[3] === 'message' ) {
      this.setState({ showFooter: true })
    } else if ( url[2] === 'dashboard' || url[2] === 'share' || url[2] === 'deposit' || url[2] === 'loan' || url[2] === 'payment' || url[2] === 'guarantor' || url[2] === 'password' || url[2] === 'message' ) {
      this.setState({ showFooter: true })
    } else if ( typeof url[2] === 'undefined' || url[2] === '' || url[2] === 'register' ) {
      this.setState({ showFooter: true })
    }
  }

  render() {
    return (
      	<div>
        { (this.state.showFooter) ?
            <div className="footer">
				<div className="ft-first">
					<div className="fix-content ft-layout">
						<div className="ft-menu col-md-5 text-center">
							{/* <div className="ft-first-title">เมนู</div>
							<ul>
								<li><a href={this.BaseUrl}>หน้าแรก</a></li>
								<li><a href={this.state.about.history}>เกี่ยวกับสหกรณ์</a></li>
								<li><a href={this.state.service.member}>บริการสมาชิก</a></li>
								<li><a href={this.state.performance}>ผลการดำเนินงาน</a></li>
								<li><a href={this.state.account}>เลขที่บัญชีธนาคาร</a></li>
								<li><a href={this.state.contact}>ติดต่อเรา</a></li>
							</ul> */}
							<img className="footer-logo" src={logo} />
							<div className="footer-left-first-line">สหกรณ์ออมทรัพย์สหภาพแรงงานรัฐวิสาหกิจรถไฟแห่งประเทศไทย จำกัด</div>
							<div className="footer-left-second-line">The State Railway Workers’ Union Saving and Credit<br/> Cooperative of Thailand Limited</div>
							<div className="footer-left-line">อาคาร 4 ศูนยฝึกอบรมการรถไฟ นิคมรถไฟ กม.11</div>
							<div className="footer-left-line">ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร กรุงเทพมหานคร 10900</div>
						</div>
						<div className="ft-contact col-md-4">
						<div className="ft-first-title">ติดต่อเรา</div>
							<div className="br-content">
								<a href="https://www.google.com/maps/place/%E0%B8%AA%E0%B8%AB%E0%B8%81%E0%B8%A3%E0%B8%93%E0%B9%8C%E0%B8%AD%E0%B8%AD%E0%B8%A1%E0%B8%97%E0%B8%A3%E0%B8%B1%E0%B8%9E%E0%B8%A2%E0%B9%8C%E0%B8%AA%E0%B8%AB%E0%B8%A0%E0%B8%B2%E0%B8%9E%E0%B9%81%E0%B8%A3%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%A3%E0%B8%B1%E0%B8%90%E0%B8%A7%E0%B8%B4%E0%B8%AA%E0%B8%B2%E0%B8%AB%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%A3%E0%B8%96%E0%B9%84%E0%B8%9F%E0%B9%81%E0%B8%AB%E0%B9%88%E0%B8%87%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%97%E0%B8%A8%E0%B9%84%E0%B8%97%E0%B8%A2/@13.815906,100.551134,16z/data=!4m5!3m4!1s0x0:0x21cb01542fe34bed!8m2!3d13.815843!4d100.551182?hl=th&shorturl=1" target="_blank">
									<div className="footer-fa text-center">
										<i className="fas fa-map-marker-alt i-icon"></i>
									</div>
								</a>
								<div className="footer-fa-right">อาคาร 4 ศูนยฝึกอบรมการรถไฟ นิคมรถไฟ กม.11 ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร กรุงเทพมหานคร 10900</div>
							</div>
							<div className="br-content">
								<div className="footer-fa text-center">
									<i className="fas fa-phone i-icon"></i>
								</div>
								<div className="footer-fa-right">
                                  โทรศัพท์ : <span style={{fontSize: '13pt' }}>02-105-4756 ต่อ 9001-9004 หรือ 02-936-0400</span> <br></br>
									มือถือ : <span style={{fontSize: '13pt' }}>086 – 3017390, 094 – 5518620</span><br></br>
									โทรสาร : <span style={{fontSize: '13pt' }}>0-2537-9140, 02-5379278, 0-2936-0400</span>
								</div>
							</div>
							<div className="br-content">
								<div className="footer-fa text-center">
									<i className="fas fa fa-envelope i-icon"></i>
								</div>
								<div className="footer-fa-right">
									Email : srusct2555@gmail.com<br></br>
									facebook : สหกรณ์ออมทรัพย์ สร.รฟท.จำกัด
								</div>
							</div>
						</div>
						<div className="ft-facebook col-md-3">
							<div className="ft-first-title">ติดตามเรา</div>
							{/* <div className="br-content">
								<a href="https://www.facebook.com/srusctcoop" target="_blank" className="btn btn-facebook btn-footer">
									<i className="fab fa-facebook i-icon" aria-hidden="true"></i>
									<div className="div-icon">facebook</div>
								</a>
							</div>
							<div className="br-content">
								<a target="_blank" className="btn btn-twitter btn-footer" href="https://twitter.com/share?url=http%3A%2F%2Fwww.srusct.or.th%2F%25e0%25b8%2595%25e0%25b8%25b4%25e0%25b8%2594%25e0%25b8%2595%25e0%25b9%2588%25e0%25b8%25ad%25e0%25b9%2580%25e0%25b8%25a3%25e0%25b8%25b2-2%2F&amp;text=%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B9%88%E0%B8%AD%E0%B9%80%E0%B8%A3%E0%B8%B2">
									<i className="fab fa-twitter i-icon" aria-hidden="true"></i>
									<div className="div-icon">twitter</div>
								</a>
							</div>
							<div className="br-content">
								<a target="_blank" className="btn btn-line btn-footer" href="https://lineit.line.me/share/ui?url=http%3A%2F%2Fwww.srusct.or.th%2F%25e0%25b8%2595%25e0%25b8%25b4%25e0%25b8%2594%25e0%25b8%2595%25e0%25b9%2588%25e0%25b8%25ad%25e0%25b9%2580%25e0%25b8%25a3%25e0%25b8%25b2-2%2F">
									<i className="fab fa-line i-icon" aria-hidden="true"></i>
									<div className="div-icon">line</div>
								</a>
							</div> */}
							<div className="br-content">
								<a href="https://www.facebook.com/srusctcoop" target="_blank">
									<div className="footer-fa text-center">
										<i className="fab fa-facebook-f i-icon" aria-hidden="true"></i>
									</div>
								</a>
								<div className="footer-fa-right">สหกรณ์ออมทรัพย์ สร.รฟท.จำกัด</div>
							</div>
						</div>
					</div>
				</div>
				<div className="fix-last">
					<div>สหกรณ์ออมทรัพย์สหภาพแรงงานรัฐวิสาหกิจรถไฟแห่งประเทศไทย จำกัด</div>
					<div>พัฒนาโดย บริษัท อัพบีน จำกัด</div>
				</div>
			</div>
         	:
            null
        }
      	</div>
    )
  }
}
export default AppFooter;
